// Turning stored values into something a person reads at a glance.

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** "just now", "12 min ago", "3 d ago", then an actual date. */
export const relativeTime = (iso, now = Date.now()) => {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const seconds = Math.round((now - then) / 1000);
  if (seconds < 45) return "just now";
  if (seconds < HOUR) return `${Math.round(seconds / MINUTE)} min ago`;
  if (seconds < DAY) return `${Math.round(seconds / HOUR)} h ago`;
  if (seconds < 30 * DAY) return `${Math.round(seconds / DAY)} d ago`;
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};

/** The full stamp, for the tooltip behind the relative one. */
export const exactTime = (iso) => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleString();
};

/**
 * Who this was, in order of what a person would recognise. Boards made before
 * the name was recorded carry only an opaque id, which is worth saying plainly
 * rather than printing `google-10457…` at somebody.
 */
export const actorName = (name, email, id) => {
  if (name) return name;
  if (email) return email;
  if (typeof id === "string" && id.startsWith("agent:")) return id.slice("agent:".length);
  return "unknown";
};

export const initialsOf = (name) =>
  (name ?? "?")
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("") || "?";

export const plural = (count, one, many = `${one}s`) => `${count} ${count === 1 ? one : many}`;
